import React from 'react';
import LoadingScreen from '../layout/LoadingScreen';

export default function LeadgenPreloader({ message = 'Finding the best leads for you...' }) {
  return <LoadingScreen message={message} />;
}
